<template>
    <b-modal ref="mdlConfigurazioneMagazzinoUmArticoli" :title="title" centered no-close-on-backdrop no-close-on-esc hide-header-close size="lg">
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Codice Azienda</label>
                <span v-if="isReadOnly"> {{ jsonDataUmArticolo.codiceAzienda }} </span>
                <b-form-input v-else v-model="jsonDataUmArticolo.codiceAzienda"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">U.M</label>
                <span v-if="isReadOnly"> {{ jsonDataUmArticolo.um }}</span>
                <b-form-input v-else v-model="jsonDataUmArticolo.um"></b-form-input>
            </b-col>

            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Descrizione U.M</label>
                <span v-if="isReadOnly">{{ jsonDataUmArticolo.descrizioneUm }}</span>
                <b-textarea v-else v-model="jsonDataUmArticolo.descrizioneUm" rows="7" max-rows="10"></b-textarea>
            </b-col>
        </b-row>

        <template #modal-footer>
            <b-button v-if="!isReadOnly" size="md" variant="outline-danger" @click="onCloseModal">Annulla</b-button>
            <b-button v-if="!isReadOnly" size="md" variant="outline-success" @click="onClickSalvaUmArticolo">Salva</b-button>
            <b-button v-if="isReadOnly" size="md" variant="outline-secondary" @click="onCloseModal">Chiudi</b-button>
        </template>
        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>

<script>
import ModalError from "../../../template/components/modal/components/ModalError.vue";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
    mixins: [UtilityMixin],
    components: { ModalError },
    data() {
        return {
            title: null,
            isReadOnly: false,
            pathResource: "/magazzinoarticolium",
            jsonDataUmArticolo: {
                id: null,
                codiceAzienda: null,
                um: null,
                descrizioneUm: null,
            },
        };
    },
    mounted() {
        console.log("Componente attivo");
    },
    methods: {
        // ==================== CRUD ====================
        onClickSalvaUmArticolo() {
            let me = this;
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonDataUmArticolo, me.salvaUmArticoloSuccess, me.salvaUmArticoloError);
        },
        salvaUmArticoloSuccess(response) {
            let me = this;
            me.$emit("saveUmArticolo", response);
            me.$refs.mdlConfigurazioneMagazzinoUmArticoli.hide();
            me.$bvToast.toast("Salvataggio avvenuto con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        salvaUmArticoloError(error) {
            let me = this;
            me.$emit("saveUmArticolo", error);
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },

        onDeleteUmArticolo(item) {
            let me = this;
            me.$bvModal
                .msgBoxConfirm("Sei sicuro di eliminare questa configurazione?", {
                    title: "Eliminazione U.M",
                    buttonSize: "sm",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    okVariant: "danger",
                    cancelVariant: "secondary",
                    hideHeaderClose: true,
                    footerClass: "p-2",
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteUmArticolo(item.id);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },

        deleteUmArticolo(id) {
            let me = this;
            UtilityMixin.methods.deleteResource(me.pathResource + "/" + id, null, me.deleteUmArticoloSuccess, me.deleteUmArticoloError);
        },
        deleteUmArticoloSuccess(response) {
            let me = this;
            me.$emit("umArticoloDelete", response);
            me.$bvToast.toast("Eliminazione avvenuta con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        deleteUmArticoloError(response) {
            let me = this;
            me.$emit("umArticoloDelete", response);
            me.$bvToast.toast("Errore durante l'eliminazione", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        // ==================== UTILITY ====================
        show(jsonDataUmArticolo, isReadOnly) {
            let me = this;
            me.jsonDataUmArticolo = jsonDataUmArticolo;
            me.isReadOnly = isReadOnly;
            if (isReadOnly) {
                me.title = "Visualizzazione Unità di Misura";
            } else {
                me.title = !jsonDataUmArticolo.id ? "Nuova Unità di Misura" : "Aggiorna Unità di Misura";
            }
            me.$refs.mdlConfigurazioneMagazzinoUmArticoli.show();
        },

        onCloseModal() {
            let me = this;
            me.jsonDataUmArticolo = {
                id: null,
                codiceAzienda: null,
                um: null,
                descrizioneUm: null,
            };
            me.$emit("onCloseModal");
            me.$refs.mdlConfigurazioneMagazzinoUmArticoli.hide();
        },
    },
};
</script>
